import { format, parseISO } from "date-fns";
import { fr, enCA } from "date-fns/locale";

export const fmtDate = (d, lang, pattern = "EEEE d MMMM yyyy") => {
  if (!d) return "";
  try {
    return format(parseISO(d), pattern, { locale: lang === "en" ? enCA : fr });
  } catch {
    return d;
  }
};

export const fmtShort = (d, lang) => fmtDate(d, lang, lang === "en" ? "EEE, MMM d" : "EEE d MMM");

export const fmtDateTime = (iso, lang) => fmtDate(iso, lang, lang === "en" ? "MMM d, HH:mm" : "d MMM, HH:mm");

export const dateParts = (d, lang) => ({
  day: fmtDate(d, lang, "d"),
  month: fmtDate(d, lang, "MMM").replace(".", ""),
  weekday: fmtDate(d, lang, "EEE").replace(".", ""),
});

export const STAFF_STYLES = {
  full: "text-emerald-700 bg-emerald-50 border-emerald-200",
  partial: "text-amber-700 bg-amber-50 border-amber-200",
  vacant: "text-red-700 bg-red-50 border-red-200",
};

export const STAFF_DOT = { full: "bg-emerald-500", partial: "bg-amber-500", vacant: "bg-red-500" };

export const ASSIGN_STYLES = {
  pending: "text-indigo-700 bg-indigo-50 border-indigo-200",
  confirmed: "text-emerald-700 bg-emerald-50 border-emerald-200",
  declined: "text-red-700 bg-red-50 border-red-200",
  cancelled: "text-neutral-500 bg-neutral-100 border-neutral-200",
};

export const AVAIL_STYLES = {
  available: "text-emerald-700 bg-emerald-50 border-emerald-200",
  maybe: "text-amber-700 bg-amber-50 border-amber-200",
  unavailable: "text-neutral-500 bg-neutral-100 border-neutral-200",
};

export const VAGUE_TIMES = ["AM", "PM", "TBD"];
export const fmtTime = (v, t) => (v === "TBD" ? (t ? t("time.tbd") : "TBD") : v || "");
export const fmtRange = (s, e, t) => `${fmtTime(s, t)}–${fmtTime(e, t)}`;

